import * as languagesKeyset from 'i18n/Language';

import { SupportedLanguageFormData } from '../../types';

export function isAvailableLanguage(lang: string): lang is import('../../types').LanguageCode {
    return lang in languagesKeyset.en;
}

export const getRtlByLanguageCode = (data: SupportedLanguageFormData) => data?.languageCode === 'ar';
